<template>
    <div>
        <header class="page-header">
            <div class="container">
                <div class="row report">
                    <div class="col-12">
                        <h2>Правила</h2>
                    </div>
                </div>
            </div>
        </header>
        <div class="container mt-4">
            <div class="alert alert-success" v-if="success">Правило успешно сохранено</div>
            <form @submit.prevent="saveRule">
                <div class="form-group">
                    <div class="form-check">
                        <input type="checkbox" id="use_same_acquiring" class="form-check-input" v-model="formData.use_same_bank">
                        <label class="form-check-label" for="use_same_acquiring">
                            Проводить транзакции по той же карте как эквайринг
                        </label>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group mr-4">
                        <label>Visa от суммы</label>
                        <input class="form-control" placeholder="5000" v-model="formData.visa_amount">
                    </div>
                    <div class="form-group">
                        <label for="acquiring_visa_from">Acquiring</label>
                        <br />
                        <select id="acquiring_visa_from" classs="form-control" v-model="formData.visa_greater_acquiring_id">
                            <option v-for="acquiring in acquirings" :value="acquiring.id">{{ acquiring.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group mr-4">
                        <label>Visa до суммы</label>
                        <input class="form-control" placeholder="5000" v-model="formData.visa_amount">
                    </div>
                    <div class="form-group">
                        <label for="acquiring_visa_to">Acquiring</label>
                        <br />
                        <select id="acquiring_visa_to" classs="form-control" v-model="formData.visa_smaller_acquiring_id">
                            <option v-for="acquiring in acquirings" :value="acquiring.id">{{ acquiring.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group mr-4">
                        <label>Mastercard от суммы</label>
                        <input class="form-control" placeholder="5000" v-model="formData.others_amount">
                    </div>
                    <div class="form-group">
                        <label for="acquiring_mc_from">Acquiring</label>
                        <br />
                        <select id="acquiring_mc_from" classs="form-control" v-model="formData.mc_greater_acquiring_id">
                            <option v-for="acquiring in acquirings" :value="acquiring.id">{{ acquiring.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group mr-4">
                        <label>MasterCard до суммы</label>
                        <input class="form-control" placeholder="5000">
                    </div>
                    <div class="form-group">
                        <label for="acquiring_mc_to">Acquiring</label>
                        <br />
                        <select id="acquiring_mc_to" classs="form-control" v-model="formData.mc_smaller_acquiring_id">
                            <option v-for="acquiring in acquirings" :value="acquiring.id">{{ acquiring.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group mr-4">
                        <label>Остальные карты от суммы</label>
                        <input class="form-control" placeholder="5000" v-model="formData.others_amount">
                    </div>
                    <div class="form-group">
                        <label for="acquiring_others_from">Acquiring</label>
                        <br />
                        <select id="acquiring_others_from" classs="form-control" v-model="formData.others_greater_acquiring_id">
                            <option v-for="acquiring in acquirings" :value="acquiring.id">{{ acquiring.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group mr-4">
                        <label>Остальные карты до суммы</label>
                        <input class="form-control" placeholder="5000">
                    </div>
                    <div class="form-group">
                        <label for="acquiring_others_to">Acquiring</label>
                        <br />
                        <select id="acquiring_others_to" classs="form-control" v-model="formData.others_smaller_acquiring_id">
                            <option v-for="acquiring in acquirings" :value="acquiring.id">{{ acquiring.name }}</option>
                        </select>
                    </div>
                </div>
                <button type="submit" class="btn btn-primary">Сохранить</button>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Rule",
        data() {
            return {
                acquirings: [],
                formData: {
                    visa_amount: 5000,
                    mc_amount: 5000,
                    others_amount: 5000,
                    visa_greater_acquiring_id: 0,
                    visa_smaller_acquiring_id: 0,
                    mc_greater_acquiring_id: 0,
                    mc_smaller_acquiring_id: 0,
                    others_greater_acquiring_id: 0,
                    others_smaller_acquiring_id: 0,
                    use_same_bank: true
                },
                success: false
            }
        },
        created() {
            this.fetchAcquirings();
            this.fetchRule();
        },
        methods: {
            fetchAcquirings() {
                axios.get('/admin/payment/acquiring').then(response => {
                    this.acquirings = response.data;
                })
            },
            fetchRule() {
                axios.get('/admin/ajax/rule').then(response => {
                    this.formData = response.data.data;
                })
            },
            saveRule() {
                axios.post('/admin/rule', this.formData).then(response => {
                    this.success = true;
                });
            }
        }
    }
</script>

<style scoped>

</style>
